<template>
     <div class="container" v-title="'核心团队'">
         <Navigation-bar title="核心团队" v-scrollShadow="roll"></Navigation-bar>
        <div class="container_content">
            <div id="CoreTeam" v-scroll="roll">
                <div class="CoreTeam_content">
                   <div class="item" v-for="(item,index) in data" :key="index">
                       <div class="item_subtitle">{{item.subtitle}}</div>
                       <ul>
                           <li v-for="(subItem,subIndex) in item.list" :key="subIndex">
                               <div class="img">
                                   <YD-image :src="`Association/核心团队/${subItem.name.replace(/\s*/g,'')}`"></YD-image>
                               </div>
                               <div class="info">
                                   <h4 class="name">{{subItem.name}}</h4>
                                   <p>{{subItem.intro}}</p>
                               </div>
                           </li>
                       </ul>
                   </div>
                </div>
            </div>
        </div>
     </div>
</template>
<script>
export default {
    name:"CoreTeam",
    data(){
        return{
            roll:0,
            data:[
                {
                    subtitle:'主席',
                    list:[
                        {
                            name:'冀运希',
                            intro:'国家体育总局社会体育指导中心原主任'
                        }
                    ]
                },
                {
                    subtitle:'副主席',
                    list:[
                        {
                            name:'戴璐强',
                            intro:'中国煤矿体育协会原主席'
                        },
                        {
                            name:'张长河',
                            intro:'中国火车头体育协会原秘书长'
                        },
                        {
                            name:'雷 平',
                            intro:'中国石油体育协会执行副主席'
                        },
                        {
                            name:'张家顺',
                            intro:'国家体育总局机关服务中心原副主任'
                        }
                    ]
                },
                {
                    subtitle:'秘书长'
                },
                {
                    subtitle:'专家团队',
                    list:[
                        {
                            name:'徐寅生',
                            intro:'乒羽委员会顾问 （国际乒联原主席、国家体委原副主任、中国乒协原主席）'
                        },
                        {
                            name:'李富荣',
                            intro:'乒羽委员会顾问（亚洲乒联原主席、国家体育总局原副局长、中国奥委会原副主席）'
                        },
                        {
                            name:'刘凤岩',
                            intro:'乒羽委员会顾问（亚洲羽联原副主席、国家体育总局乒羽中心原主任、中国乒协原副主席、中国羽协原副主席）'
                        },
                        {
                            name:'陆元盛',
                            intro:'乒羽委员会教练委员会主任（国家体育总局乒羽中心原主任助理、中国乒协原副主席、中国乒乓球女队原主教练）'
                        },
                        {
                            name:'容志行',
                            intro:'足球委员会总顾问（深圳市体育局原局长）'
                        },
                        {
                            name:'戚务生',
                            intro:'足球委员会总顾问（中国男足原主教练）'
                        },
                        {
                            name:'马元安',
                            intro:'职工足球委员会总顾问（中国女足原主教练）'
                        },
                        {
                            name:'沈祥福',
                            intro:'足球委员会主席（中国足球协会执委、技术委员会主任，中国男足原主教练）'
                        },
                        {
                            name:'惠若琪',
                            intro:'排球委员会主席（国际排联市场和通讯委员会委员、江苏省青年联合会副主席、中国女排前队长、女排奥运冠军、中国社会福利基金会惠基金发起人）'
                        }
                    ]
                }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
#CoreTeam{
    .CoreTeam_content{
        padding: 0 40px;
        box-sizing: border-box;
    }
    .item{
        .item_subtitle{
            width: 100%;
            @include line-height(44px);
            font-size: 32px;
            color: #1B1C1E;
            letter-spacing: 0;
            font-weight: 500;
            margin-bottom: 32px;
        }
        ul{
            margin-bottom: 40px;
            li{
                width: 100%;
                height: auto;
                background: #FBFBFD;
                border-radius: 66px;
                padding: 44px 40px 32px;
                box-sizing: border-box;
                margin-bottom: 24px;
                display: flex;
                &:last-of-type{
                    margin-bottom: 0;
                }
                .img{
                    width: 160px;
                    height: 160px;
                    margin-bottom: 12px;
                    position: relative;
                    &::after{
                        content: '';
                        width: 128px;
                        height: 80px;
                        background: url('~@images/Association/投影@2x.png') no-repeat 100% 100%;
                        position: absolute;
                        left: 16px;
                        bottom: -14px;
                    }
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .info{
                    width: calc(100% - 192px);
                    height: auto;
                    margin-left: 32px;
                    padding-top: 8px;
                    .name{
                        font-size: 32px;
                        color: #FF7935;
                        line-height: 40px;
                        font-weight: 500;
                    }
                    p{
                        font-size: 28px;
                        color: #8B8C8D;
                        line-height: 38px;
                        font-weight: 400;
                        margin-top: 20px;
                    }
                }
            }
        }
    }
}
</style>